import Box from '@mui/material/Box';
import React, { useState } from 'react';
import FormControl from '@mui/material/FormControl';
import AutoComplete from '@mui/material/Autocomplete';
import TextField from '@mui/material/TextField';
import DialogActions from '@mui/material/DialogActions';
import DialogContent from '@mui/material/DialogContent';
import DialogTitle from '@mui/material/DialogTitle';
import Dialog from '@mui/material/Dialog';
import Button from '@mui/material/Button';
import SaveIcon from '@mui/icons-material/Save';
import IconButton from '@mui/material/IconButton';
import Tooltip from '@mui/material/Tooltip';
import dayjs from 'dayjs';
import utc from 'dayjs/plugin/utc';
import operationsHelpers from '../../helpers/operations';
import ToggleOnIcon from '@mui/icons-material/ToggleOn';
import ToggleOffIcon from '@mui/icons-material/ToggleOff';

dayjs.extend(utc)

function EditWorkerPopup(props) {

    const worker = props.selectedRow;
    const [payrollNum, setPayrollNum] = useState(worker.payroll_num || '');
    const [timecardNum, setTimecardNum] = useState(worker.timecard_num || '');
    const [warehouse, setWarehouse] = useState(worker.warehouse || '');
    const [name, setName] = useState(worker.worker_name || '');
    const [status, setStatus] = useState(worker.status || '');

    const handleChange = (event) => {
        let func = `set${event.target.name[0].toUpperCase() + event.target.name.substring(1)}`;
        eval(func)(event.target.value);
    };

    const requiredFields = [
        { field: 'worker_name', message: 'Name is required.'},
        { field: 'warehouse', message: 'Warehouse is required.'},
        { field: 'timecard_num', message: 'Timecard Number is required.'},
    ];
    
    const checkValidity = (workerInfo) => {
        let errorMessages = [];
        
        for (const { field, message } of requiredFields) {
            if (!workerInfo[field]) {
                errorMessages.push(message);
            };
        };
    
        if (errorMessages.length > 0) {
            const error_message = errorMessages.join('\n');
            props.toast.error(error_message);
            return false;
        };
        return true;
    };

    const updateWorkersState = (workerInfo) => {
        const updatedWorkers = [];
        props.workers.forEach(worker => {
            if (worker.id === workerInfo.id) {
                const updatedWorker = {
                    ...worker,
                    ...workerInfo
                }
                updatedWorkers.push(updatedWorker);
            } else {
                updatedWorkers.push(worker);
            };
        });
        props.setWorkers(updatedWorkers);
    };

    const updateWorker = async () => {
        props.setLoading(true);

        const params = {
            worker_name: name ? name : null,
            warehouse: warehouse ? warehouse : null,
            timecard_num: timecardNum ? timecardNum : null,
            payroll_num: payrollNum ? payrollNum : null,
            id: worker.id
        };

        if (!checkValidity(params)) {
            props.setLoading(false);
            return;
        };

        try {
            if (window.confirm(`Confirm changes.`)) {
                const res = await operationsHelpers.updateWorker(params, props.company, props.token);
                if (res) {
                    updateWorkersState(params);
                    props.toast.success('Saved Changes!');
                    props.handleClose();
                } else {
                    props.toast.error('Failed to Save Changes!');
                };
            };
        } catch(err) {
            console.log(err);
            props.toast.error('Failed to Save Changes!');
        } finally {
            props.setLoading(false);
        };
    };

    const toggleWorkerStatus = async () => {
        const newStatus = status === 'Active' ? 'Inactive' : 'Active';
        const action = newStatus === 'Active' ? 'Activate' : 'Deactivate';
    
        if (!window.confirm(`${action} worker ${worker.worker_name}?`)) return;
    
        props.setLoading(true);
    
        const params = {
            status: newStatus,
            id: worker.id
        };
    
        try {
            const res = await operationsHelpers.updateWorker(params, props.company, props.token);
            if (res) {
                setStatus(newStatus);
                updateWorkersState(params);
                props.toast.success(`${action}d ${worker.worker_name}`);
                props.handleClose();
            } else {
                props.toast.error(`Failed to ${action.toLowerCase()}.`);
            };
        } catch (err) {
            console.log(err);
            props.toast.error(`Failed to ${action.toLowerCase()}!`);
        } finally {
            props.setLoading(false);
        };
    };    

    const warehouse_options = [
        { value: "PA", name: "PA"},
    ];

    return (
        <Dialog open = {props.open} onClose = {() => props.handleClose()} fullWidth = {true} maxWidth = {'md'}>
            <Box sx = {{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', padding: '12px' }}>
                <DialogContent>
                    <Box className = {props.isMobile ? "mobile-box" : "desktop-box"} sx = {{ display: 'flex', flexDirection: 'column' }}>
                        <DialogTitle>
                            <Box sx = {{ display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
                                <span> Edit Worker Information </span>
                                <Box>
                                    {status === 'Active' ? (
                                        <Tooltip title = "Deactivate worker." placement = "right">
                                            <span>
                                                <IconButton
                                                    aria-label = "deactivate_worker"
                                                    onClick = {toggleWorkerStatus}
                                                    sx = {{ color: 'green' }}
                                                >
                                                    <ToggleOnIcon fontSize = 'large'/>
                                                </IconButton>
                                            </span>
                                        </Tooltip>
                                    ) : status === 'Inactive' ? (
                                        <Tooltip title = "Activate worker." placement = "right">
                                            <span>
                                                <IconButton
                                                    aria-label = "activate_worker"
                                                    onClick = {toggleWorkerStatus}
                                                    sx = {{ color: 'red' }}
                                                >
                                                    <ToggleOffIcon fontSize = 'large'/>
                                                </IconButton>
                                            </span>
                                        </Tooltip>
                                    ) : null}
                                </Box>
                            </Box>
                        </DialogTitle>     
                        <Box className = {props.isMobile ? "mobile-box" : "desktop-box"} sx = {{ display: 'flex', flexDirection: props.isMobile ? 'column' : 'row', mb: '10px' }}>
                            <TextField 
                                name = 'name'
                                label = 'Name'
                                onChange = {handleChange}
                                value = {name}
                                sx = {{ width: '25%', mr: '0.6%' }}
                                required
                            />
                            <FormControl sx = {{ width: '25%', mr: '0.6%' }}>
                                <AutoComplete
                                    value = {warehouse}
                                    key = {warehouse}
                                    onChange = {(event, newValue) => {
                                        setWarehouse(newValue ? newValue.value : null);
                                    }}
                                    id = "warehouse"
                                    options = {warehouse_options}
                                    getOptionLabel = {(option) => {
                                        if (!option.name) {
                                            return option;
                                        }
                                        return option.name;
                                    }}
                                    renderOption = {(props, option) => {
                                        let name = option.name;
                                        if (!name) {
                                            return option;
                                        }
                                        return (
                                            <li {...props}>
                                                {name}
                                            </li>
                                        );
                                    }}
                                    freeSolo
                                    forcePopupIcon = {true}
                                    renderInput = {(params) => (
                                        <TextField {...params} label = "Warehouse *" />
                                    )}
                                    required
                                />
                            </FormControl>
                            <TextField 
                                name = 'timecardNum'
                                label = 'Timecard Number'
                                onChange = {handleChange}
                                value = {timecardNum}
                                sx = {{ width: '25%', mr: '0.6%' }}
                                required
                            />
                            <TextField 
                                name = 'payrollNum'
                                label = 'Payroll Number'
                                onChange = {handleChange}
                                value = {payrollNum}
                                sx = {{ width: '25%', mr: '0.6%' }}
                            />
                        </Box>
                        <Box className = {props.isMobile ? "mobile-box" : "desktop-box"} sx = {{ flexDirection: 'row' }}>
                            <DialogActions>
                                <Button 
                                    variant = "contained" 
                                    onClick = {() => updateWorker()} 
                                    disabled = {props.isLoading} 
                                    color = "success" 
                                    endIcon = {<SaveIcon />}
                                >
                                    Save
                                </Button>
                            </DialogActions>
                        </Box>
                    </Box>             
                </DialogContent>

            </Box>
        </Dialog>
    );
};

export default EditWorkerPopup;